module.exports = __webpack_public_path__ + "img/weddings_05_V.f31b9e8f.webp";